<template>
  <div class="czzn-ztgl">
    <div class="czsc-con">
      <div class="czsc-nr-tit">【账套管理】</div>
      <div class="czsc-nr-ct-box">新建账套</div>
      <p>账号第一次登录，会默认出现建账界面，以后管理员登录后可在企业管理工作台中点击新建账套按钮进行建账。（如下图）</p>
      <img src="@/assets/images/czzn_002.png" />
      <p>点击“新建账套”按钮，出现如下图所示新建账套界面。根据企业相应信息填写或选择：</p>
      <img class="small60" src="@/assets/images/czzn_003.png" />
      <p><span class="czsc-nr-ct" >单位名称：</span>会默认显示注册时所填写的单位名称，可根据实际情况进行修改；</p>
      <p><span class="czsc-nr-ct" >账套名称：</span>新建账套的名称，会显示在e记账首页左上方的账套下拉菜单里，供切换账套选用；</p>
      <p><span class="czsc-nr-ct" >会计制度：</span>e记账目前支持 3 种会计制度（企业会计制度、小企业会计准则、个体工商户会计制度））当前大多数企业都可以适用这 3类会计制度；（很多行业的会计制度已经明确废止，例如商业、工业、房地产业……）</p>
      <p><span class="czsc-nr-ct" >启用期间：</span>建立当前账套的启用年月；</p>
      <p><span class="czsc-nr-ct" >账套参数：</span>单价精度、数量精度、科目级次维护和设置；</p>
      <p><span class="czsc-nr-ct" >纳税性质：</span>根据增值税纳税人划分的两类纳税人身份，e记账会根据纳税人身份进行相应的财税服务。</p>
      <div class="czsc-nr-hsbj-box">
        <div ><span class="czsc-nr-ct">小提示：</span></div>
        <p>1、会计主管和出纳设置后会体现到凭证录入表尾处；</p>
        <p>2、科目级次设置后将不能修改，需提前规划好；</p>
      </div>
      <div class="czsc-nr-ct-box">修改、删除账套</div>
      <p>只有管理员身份，才会出现“授权”“ 修改”“删除”账套的按钮。</p>
      <div class="czsc-nr-tit">【角色管理】</div>
      <img src="@/assets/images/czzn_004.png" />
      <p>1、系统预制会计、出纳、会计主管、手机端查看者四种角色，预制角色不可进行删除；</p>
      <p>2、角色对应的权限系统初始预制，但用户可以根据实际情况进行修改，但系统会控制部分权限不能删除；</p>
      <p>3、角色支持用户新增、修改、删除；角色权限会分三级，第一级子系统，第二级功能大类，第三级操作功能；</p>
      <p>4、手机端查看者目前具体功能权限不做细分，后续根据需求再扩展；</p>
      <div class="czsc-nr-tit">【用户管理】</div>
      <img src="@/assets/images/czzn_005.png" />
      <p>新增用户：需要输入新增用户的姓名和手机号码，都为必填项目，如下图：</p>
      <img src="@/assets/images/czzn_006.png" />
      <p>1、如该手机号非平台注册过用户，那么需先进行注册操作；</p>
      <p>2、如用户不在该岗位或其他原因不再操作此公司的所有账套，可以执行【禁用】操作；如后期再操作也可以执行【启用】操作；</p>
      <p>3、如果该用户只是不操作该企业的其中一套账，那么不能执行【禁用】操作，需要在我的账套中选中对应的账套进行取消授权操作；</p>
      <div class="czsc-nr-tit">【账号设置】</div>
      <p>登录用户，可以在此查看/修改自己的个人信息、修改密码、更换超级管理员（超级管理员特有权限）</p>
      <img src="@/assets/images/czzn_007.png" />
      <p><span class="czsc-nr-ct">修改个人信息：</span>用户名为注册手机号，不可修改，姓名会自动带出注册时的联系人，也可修改，如下图：</p>
      <img src="@/assets/images/czzn_008.png" />
      <p><span class="czsc-nr-ct">修改密码：</span>输入原密码进项修改即可，如下图：</p>
      <img src="@/assets/images/czzn_009.png" />
      <p><span class="czsc-nr-ct">更换管理员：</span>企业管理员可以进行移交，不负责管理可以将管理员身份移交给他人；移交时需要当前管理员和接收管理员双方输入手机短信验证码方可成功；</p>
      <img src="@/assets/images/czzn_010.png" />
      <img src="@/assets/images/czzn_011.png" />
      <div class="czsc-nr-ct-box" >说明：</div>
      <p>1、接收管理员者需是本企业用户，如不是，需先在用户管理里面添加该用户；</p>
      <p>2、更换超级管理员分三种情况，一种是接收人本来已是平台其他企业超级管理员或普票用户，移交后对方将会成为多重企业的用户身份，将来在登录时就会弹出单位选择界面；另外一种是接收人非平台用户，需先添加接收人为企业用户，然后将管理员移交对方；</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'czzn_ztgl',
};
</script>
